const deepEqual = (left, right) => {
  if (Object.is(left, right)) {
    return true;
  }

  if (left === null || right === null) {
    return false;
  }

  if (typeof left !== typeof right) {
    return false;
  }

  if (typeof left !== 'object') {
    return false;
  }

  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
      return false;
    }

    for (let i = 0; i < left.length; i += 1) {
      if (!deepEqual(left[i], right[i])) {
        return false;
      }
    }

    return true;
  }

  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  for (const key of leftKeys) {
    if (!Object.prototype.hasOwnProperty.call(right, key)) {
      return false;
    }

    if (!deepEqual(left[key], right[key])) {
      return false;
    }
  }

  return true;
};

export default deepEqual;
